import PropTypes from 'prop-types';
import React from 'react';

const GRID_COLUMNS = 12;

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const Column = ({
    children  = null,
    className = null
}) => {
    return (
        <div className={className}>
            {children}
        </div>
    );
};

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const Columns = ({
    count      = 2,
    items      = null,
    responsive = null,
}) => {
    // return null if no items provided
    if (!Array.isArray(items)) { return null; }

    // create columns matrix
    const colMatrix = new Array(count).fill(null).map(() => { return new Array(); });

    // push items in to columns matrix
    let colMatrixIndex = 0;
    items.forEach((item) => {
        colMatrix[colMatrixIndex].push(item);
        colMatrixIndex = (colMatrixIndex >= (count - 1)) ? 0 : colMatrixIndex + 1;
    });

    // create component
    const colMatrixComponent = colMatrix.map((col, idx) => {
        const classString = responsive ? `col-12 sm-col-${Math.floor(GRID_COLUMNS / count)}` : `col-${Math.floor(GRID_COLUMNS / count)}`;

        return (
            <Column
                className={classString}
                key={idx}>
                {col}
            </Column>
        );
    });

    return colMatrixComponent;
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

Column.propTypes = {
    children:  PropTypes.any,
    className: PropTypes.string,
};

Columns.propTypes = {
    count:      PropTypes.number,
    items:      PropTypes.array,
    responsive: PropTypes.bool,
};

export { Columns };

export default Columns;
